<router-outlet></router-outlet>
<div style="position: fixed; right: 0; bottom: 0; line-height: 1rem; z-index: -1;">
    <div class="m-2 p-1" style="opacity: 0.25;">
        <div class="text-end">
            <small class="text-dark font-monospace">production:
                <span class="font-monospace">{{ production }}</span>
            </small>
        </div>
        <div class="text-end">
            <small class="text-dark font-monospace">host:
                <span class="font-monospace">{{ defaultHost }}</span>
            </small>
        </div>
    </div>
</div>